/* [PATCH aplikacije-fe v1] Izbira podjetja — JSX prenesen 1:1 iz DashboardPage.tsx (blok `if (!selectedCompany)`),
   parametriziran samo z naslovom/podnaslovom in klicem onIzberi. Uporablja ga nadzorna plošča (kot prej)
   in vstopna stran /izbira-podjetja. Prazen naslov = brez glave. */
import React, { useMemo, useState } from 'react'; // [PATCH izbira-podjetij-isci v1]
import { useNavigate } from 'react-router-dom';
import { Building2, ChevronRight, Loader, Search, X } from 'lucide-react'; // [PATCH izbira-podjetij-isci v1]
import { useMojeAplikacije } from '../hooks/useAplikacija'; // [PATCH pravice-app-podjetje v1]
import { preberiAplikacijo } from '../aplikacije'; // [PATCH pravice-app-podjetje v1]

export function IzbiraPodjetja({ companies, loading, smeOdpirati, onIzberi, naslov = 'Dobrodošli v AlfaBerg', podnaslov = 'Izberite podjetje s katerim želite delati' }: {
  companies: any[]; loading: boolean; smeOdpirati: boolean; onIzberi: (c: any) => void; naslov?: string; podnaslov?: string;
}) {
  const navigate = useNavigate();
  const izberi = onIzberi;
  /* [PATCH pravice-app-podjetje v1] v aplikaciji samo podjetja, kjer jo uporabnik ima (brez konteksta aplikacije = vsa) */
  const { podatki: _mojeApl } = useMojeAplikacije();
  const _apl = preberiAplikacijo();
  const _dovP = _apl && _mojeApl?.podjetja_po_aplikaciji ? new Set(_mojeApl.podjetja_po_aplikaciji[_apl] || []) : null;
  /* [PATCH izbira-podjetij-isci v1] iskalni niz + izpeljan seznam — 1:1 iz MojaPodjetjaPage.tsx
     ([PATCH podjetja-isci-abeceda v1]), preimenovano samo podjetja -> companies. */
  const [q, setQ] = useState('');
  const _normP = (v: any) =>
    String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  /* [PATCH podjetja-isci-abeceda v1] izpeljan seznam za prikaz: abecedno po
     nazivu (slovenska kolacija) + filter po nazivu IN davcni. Vir `companies`
     ostane nedotaknjen, zato se osvezitev in izbris obnasata kot prej. */
  const podjetjaPrikaz = useMemo(() => {
    const urejena = [...(_dovP ? companies.filter((c: any) => _dovP.has(String(c.id))) : companies)].sort( // [PATCH pravice-app-podjetje v1]
     (a: any, b: any) =>
      String(a?.name || '').localeCompare(String(b?.name || ''), 'sl', { numeric: true })
    );
    const niz = _normP(q).trim();
    if (!niz) return urejena;
    const zetoni = niz.split(/\s+/).filter(Boolean);
    return urejena.filter((c: any) => {
      const naziv = _normP(c?.name);
      const dav = _normP(c?.tax_number || c?.vat_number).replace(/[^0-9a-z]/g, '');
      const davSt = dav.replace(/[^0-9]/g, '');
      return zetoni.every((z: string) => {
        if (naziv.includes(z)) return true;
        if (dav && dav.includes(z)) return true;
        const zSt = z.replace(/[^0-9]/g, '');   // "si33013926" -> "33013926"
        return !!zSt && !!davSt && davSt.includes(zSt);
      });
    });
  }, [companies, q, _mojeApl]); // [PATCH pravice-app-podjetje v1]
  return (
      <div className="space-y-6">
        <div>
          {naslov && <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{naslov}</h1>}
          {podnaslov && <p className="text-gray-500 dark:text-gray-400 mt-1">{podnaslov}</p>}
        </div>

        {/* [PATCH izbira-podjetij-isci v1] iskalnik po nazivu in davcni stevilki (kot Moja podjetja) */}
        {!loading && companies.length > 0 && (
          <div>
            <div className="relative">
              <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
              <input
                type="text"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Escape') setQ(''); }}
                placeholder="Išči po nazivu ali davčni številki …"
                className="w-full pl-9 pr-9 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-200 dark:focus:ring-blue-900"
              />
              {q && (
                <button
                  onClick={() => setQ('')}
                  title="Počisti"
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
            {q && (
              <div className="mt-1 text-xs text-gray-400">
                {podjetjaPrikaz.length} od {companies.length}
              </div>
            )}
          </div>
        )}

        {loading ? (
          <div className="flex items-center justify-center h-48">
            <Loader className="w-8 h-8 text-blue-500 animate-spin" />
          </div>
        ) : companies.length === 0 ? (
          <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-12 text-center">
            <Building2 className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">Ni dodanih podjetij</p>
            <p className="text-sm text-gray-400 mt-1">Dodajte stranko v razdelku Šifranti</p>
          </div>
        ) : podjetjaPrikaz.length === 0 ? (
          /* [PATCH izbira-podjetij-isci v1] prazen rezultat iskanja */
          <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-12 text-center">
            <Building2 className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">
              Ni zadetkov za <span className="font-medium">{q}</span>
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {podjetjaPrikaz.map((c: any) => ( /* [PATCH izbira-podjetij-isci v1] */
              <button key={c.id} onClick={() => izberi(c)}
                className="text-left bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-5 hover:border-blue-400 hover:shadow-md transition group">
                <div className="flex items-center justify-between">
                  <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 dark:text-blue-400 font-bold text-lg flex-shrink-0">
                    {(c.short_name || c.name || '?')[0].toUpperCase()}
                  </div>
                  <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-blue-400 transition" />
                </div>
                <div className="mt-3">
                  <p className="font-semibold text-gray-900 dark:text-white">{c.name}</p>
                  {c.tax_number && <p className="text-xs text-gray-500 mt-0.5">DŠ: {c.tax_number}</p>}
                  {c.vat_number && <p className="text-xs text-gray-500">ID DDV: {c.vat_number}</p>}
                </div>
              </button>
            ))}
            {/* [PATCH odpiranje-baz-fe v1] gumb samo za tiste s pravico */}
            {smeOdpirati && (
            <button onClick={() => navigate('/onboarding')}
              className="text-left bg-white dark:bg-gray-900 rounded-2xl border-2 border-dashed border-gray-300 dark:border-gray-700 p-5 hover:border-blue-400 hover:shadow-md transition group flex flex-col items-center justify-center min-h-[120px]">
              <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 dark:text-blue-400 mb-2">
                <Building2 className="w-5 h-5" />
              </div>
              <p className="font-semibold text-blue-600 dark:text-blue-400">+ Dodaj novo podjetje</p>
            </button>
            )}
          </div>
        )}
      </div>
  );
}
